// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"112c03837f1da23e5476","444":"9ff55562493316ac7d8d","659":"6a90d65eb17c3de2fcfe"}[chunkId] + ".js";
};